import {
  betStore,
  GameModes,
  popupStore,
  parseQuery,
  freeBetStore,
  userInfoStore,
  roundInfoStore,
  gameResultStore,
  gameConfigStore,
  applicationStore,
  notificationStore,
  userSettingsStore,
  DefaultQueryParams,
  loadingStore,
} from '@pascal/pascal-core';

import { worker } from '../index';
import { PopupTypes } from '../enums/popupTypes';
import { removePastRoundBets } from '../conatiners';
import { gameLiveConnection } from './GameConnection';
import { soundService, soundTypes } from './soundService';
import { doBetsStore, roundsInfoStore, roundTimeStore } from '../store';

class GameService {
  onGetInitialStateResult({ results, roundInfo, limits, currentBets, rate, balance, precision, currencyCode }) {
    const { betsClosedDuration, second } = roundInfo;
    const { setIsShowBetBlocks, setIsBetBlocksClickable } = doBetsStore;
    const { [DefaultQueryParams.Mode]: mode } = parseQuery(window.location.search);
    if (mode === GameModes.Fun) {
      applicationStore.setIsDemo(true);
    }
    roundsInfoStore.setRoundsInfo(roundInfo);

    if (second > 0) {
      setIsShowBetBlocks(true);
      setIsBetBlocksClickable(true);
    } else {
      doBetsStore.setBetClosedState(true);
      setIsShowBetBlocks(second > -betsClosedDuration);
    }

    if (roundInfo.second > 0) {
      const time = Math.ceil(Math.abs(roundInfo.second));
      roundTimeStore.setTime(time);
      this.sendWorker(time);
    }

    roundTimeStore.setDuration(roundInfo.duration);
    roundTimeStore.setPassedSeconds(roundInfo.second > 0 ? roundInfo.duration - roundInfo.second - 1 : 0);
    gameResultStore.setGameResults(results);
    roundInfoStore.setRoundInfo({ ...roundInfo, roundId: roundInfo.roundIds[0] });
    gameConfigStore.setLimits(limits);

    userInfoStore.setUserInfo({
      rate,
      balance,
      precision,
      currencyCode,
    });

    loadingStore.updateLoading({ isGameInitialLoaded: true });
    if (currentBets && currentBets.length) {
      currentBets.forEach((roundBets) => {
        const additionalData = {
          roundId: roundBets.roundId,
          userId: roundBets.userId,
          currencyCode: roundBets.currencyCode,
          freeBetId: roundBets.freeBetId,
        };
        roundBets.betData.markets.forEach((bet) => {
          betStore.updateLiveBets({ ...bet, ...additionalData });
        });
      });
      // const userCurrentBets = currentBets.filter(
      //   (item) => item?.playerExternalId === userInfoStore.playerExternalId && !item.winAmount
      // );
      // userCurrentBets.forEach((item) => {
      //   if (item.status === BetStatus.Pending) {
      //   }
      // });
    }
  }

  handleRoundStart({ data: { additionalData, results, startedRound } }) {
    freeBetStore.handleFreeBetEndedData();
    doBetsStore.setIsRequiredRedrawGame(true);
    const { isDemo } = applicationStore;
    if (isDemo) {
      //   roundsInfoStore.updateDemoBetHistory();
      popupStore.updateDemoBetsCount();
    }
    roundInfoStore.setRoundId(startedRound.roundId);
    setTimeout(() => {
      if (roundsInfoStore.isTabVisibility) {
        roundsInfoStore.setCurrentRoundId(startedRound.roundId);
      }
      roundInfoStore.setRoundId(startedRound.roundId);
      removePastRoundBets();
    }, 1000);
    window.arrowData = {};
    roundsInfoStore.cleanUnderOverBets();
    doBetsStore.setBetClosedState(false);
    gameResultStore.setGameResults(results);
    doBetsStore.setBetBlocks(additionalData.betBlocks);
    doBetsStore.setIsShowBetBlocks(true);
    doBetsStore.setIsBetBlocksClickable(true);
    roundsInfoStore.addNewRoundsInBetsHistory(additionalData.betBlocks);
    // if(document.visibilityState){
    //   backgroundAnimationService.animateHorizontalBack();
    // }
    this.sendWorker(roundTimeStore.duration);
    roundTimeStore.resetPassedSeconds();

    //betStore.setLiveBets([]);
  }

  handleRoundFin({ data: { finishedRound, bets } }) {
    roundsInfoStore.setLastWinBets(bets);
    doBetsStore.setIsShowBetBlocks(false);
    roundsInfoStore.setAnimatingPoints(finishedRound.roundData.dots);
    roundsInfoStore.setLastResult(finishedRound.roundData.resultPoint);
    roundsInfoStore.addRoundResult(finishedRound.id, finishedRound.roundData.resultPoint);
  }

  handleBetsClosed() {
    // const { isDemo } = applicationStore;
    doBetsStore.setIsBetBlocksClickable(false);
    doBetsStore.setHoveredBlock(null);

    roundTimeStore.setTime(null);
    doBetsStore.setBetClosedState(true);
    if (doBetsStore.getDoBetState().length) {
      this.sendBet();
    }
    // else if (isDemo) {
    //   roundsInfoStore.doBetForDemo();
    // }
  }

  sendBet() {
    // gameLiveConnection.doBet(doBetsStore.getDoBetState());
    const { gameTypeId } = gameConfigStore;
    const { activeFreeBet } = freeBetStore;
    const freeBetId = activeFreeBet.id ? activeFreeBet.id : null;

    gameLiveConnection.doBet({
      betData: doBetsStore.getDoBetState(),
      gameTypeId,
      freeBetId,
    });
  }

  handleDoBetResult(result) {
    // const { isDemo } = applicationStore;
    const { userId } = userInfoStore;
    const { responseCode } = result;
    if (+userId === result.userId) {
      roundsInfoStore.handleNewBets(result);
      notificationStore.setNotificationType({ responseCode });
      soundService.playBetAccepted();
    }

    result.betData.forEach((roundBets) => {
      if (roundBets.freeBetId) {
        roundBets.markets.forEach(() => freeBetStore.handleFreeBetDoBetResult(roundBets.freeBetId));
      }

      const additionalData = {
        userId: result.userId,
        roundId: roundBets.roundId,
        freeBetId: roundBets.freeBetId,
        currencyCode: result.currencyCode,
      };
      roundBets.markets.forEach((bet) => betStore.updateLiveBets({ ...bet, ...additionalData }));
    });
  }

  handleDoBetResultValidation({ responseCode }) {
    notificationStore.setNotificationType({ responseCode });
    doBetsStore.setBetBlocksClicked(false);
  }

  countDown({ data: time }) {
    roundTimeStore.setTime(time);
    if (typeof time === 'number') {
      const { isSoundOn } = userSettingsStore;
      const pathname = window.location.pathname;
      if (pathname === '/luckydeal/game') {
        isSoundOn && soundService.play(soundTypes.timer);
        doBetsStore.setIsRequiredRedrawGame(true);
      }
    }
  }

  sendWorker(timerValue) {
    if (timerValue) {
      worker.addEventListener('message', this.countDown);
      worker.postMessage(timerValue);
    } else {
      worker.removeEventListener('message', this.countDown);
    }
  }

  handleReconnecting(error) {
    if (error && error.message) {
      // eslint-disable-next-line
      popupStore.toggleReconnect();
      // this.socketRecursiveReconnecting();
    } else {
      GameService.ReconnectCount += 1;
      popupStore.toggleReconnect();
    }
  }

  handleReconnected() {
    GameService.ReconnectCount = 0;
    if (popupStore.popupName !== PopupTypes.ConnectionError) {
      popupStore.toggleReconnect();
      popupStore.close();
    }
  }

  handleConnectionError() {
    if (GameService.ReconnectCount) {
      popupStore.open({ name: PopupTypes.ConnectionError });
      popupStore.onConnectionError(true);
    }
  }

  // socketRecursiveReconnecting() {
  //   try {
  //     liveConnection
  //       .restartGameConnection()
  //       .then((connectionData) => {
  //         liveConnection.connectionInitCallback(connectionData);
  //         clearTimeout(timeOutId);
  //       })
  //       .catch(() => {
  //         timeOutId = setTimeout(() => {
  //           this.socketRecursiveReconnecting();
  //         }, 4000);
  //       });
  //   } catch (err) {
  //     popupStore.onConnectionError(true);
  //   }
  // }
}

export const gameService = new GameService();
